// extracted by mini-css-extract-plugin
module.exports = {"BarFactorChart":"BarFactorChart_BarFactorChart__2kITe"};